import { useState, useEffect } from 'react';

export const useDebounce = (value: string, interval: number) => {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, interval);

		return () => {
			clearTimeout(handler);
		};
	}, [value, interval]);

	return debouncedValue;
};
